import React from "react";
import classes from "./terms.module.css";
function Privacy() {
  return (
    <div className={classes.container}>
      <>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="Generator" content="Microsoft Word 15 (filtered)" />
        <style
          dangerouslySetInnerHTML={{
            __html:
              '\n<!--\n /* Font Definitions */\n @font-face\n\t{font-family:Helvetica;\n\tpanose-1:2 11 6 4 2 2 2 2 2 4;}\n@font-face\n\t{font-family:Wingdings;\n\tpanose-1:5 0 0 0 0 0 0 0 0 0;}\n@font-face\n\t{font-family:"Cambria Math";\n\tpanose-1:2 4 5 3 5 4 6 3 2 4;}\n@font-face\n\t{font-family:Calibri;\n\tpanose-1:2 15 5 2 2 2 4 3 2 4;}\n@font-face\n\t{font-family:"DengXian Light";\n\tpanose-1:2 1 6 0 3 1 1 1 1 1;}\n@font-face\n\t{font-family:Roboto;}\n@font-face\n\t{font-family:"Roboto Light";}\n@font-face\n\t{font-family:"Roboto Medium";}\n@font-face\n\t{font-family:"\\@DengXian Light";}\n /* Style Definitions */\n p.MsoNormal, li.MsoNormal, div.MsoNormal\n\t{margin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:6.0pt;\n\tmargin-left:0in;\n\tline-height:120%;\n\tfont-size:10.5pt;\n\tfont-family:"Calibri",sans-serif;\n\tcolor:#595959;}\nh1\n\t{mso-style-link:"Heading 1 Char";\n\tmargin-top:12.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:3.0pt;\n\tmargin-left:.25in;\n\ttext-indent:-.25in;\n\tline-height:120%;\n\tfont-size:12.0pt;\n\tfont-family:"Calibri",sans-serif;\n\tcolor:#5B9BD5;}\nh2\n\t{mso-style-link:"Heading 2 Char";\n\tmargin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:3.0pt;\n\tmargin-left:18.7pt;\n\ttext-indent:-18.7pt;\n\tline-height:120%;\n\tfont-size:10.5pt;\n\tfont-family:"Calibri",sans-serif;\n\tcolor:#595959;\n\tfont-weight:normal;\n\ttext-decoration:underline;}\np.MsoTitle, li.MsoTitle, div.MsoTitle\n\t{mso-style-link:"Title Char";\n\tmargin:0in;\n\ttext-align:center;\n\tfont-size:28.0pt;\n\tfont-family:"Calibri Light",sans-serif;\n\tletter-spacing:-.5pt;}\np.MsoTitleCxSpFirst, li.MsoTitleCxSpFirst, div.MsoTitleCxSpFirst\n\t{mso-style-link:"Title Char";\n\tmargin:0in;\n\ttext-align:center;\n\tfont-size:28.0pt;\n\tfont-family:"Calibri Light",sans-serif;\n\tletter-spacing:-.5pt;}\np.MsoTitleCxSpMiddle, li.MsoTitleCxSpMiddle, div.MsoTitleCxSpMiddle\n\t{mso-style-link:"Title Char";\n\tmargin:0in;\n\ttext-align:center;\n\tfont-size:28.0pt;\n\tfont-family:"Calibri Light",sans-serif;\n\tletter-spacing:-.5pt;}\np.MsoTitleCxSpLast, li.MsoTitleCxSpLast, div.MsoTitleCxSpLast\n\t{mso-style-link:"Title Char";\n\tmargin:0in;\n\ttext-align:center;\n\tfont-size:28.0pt;\n\tfont-family:"Calibri Light",sans-serif;\n\tletter-spacing:-.5pt;}\na:link, span.MsoHyperlink\n\t{color:#0563C1;\n\ttext-decoration:underline;}\np.MsoListParagraph, li.MsoListParagraph, div.MsoListParagraph\n\t{margin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:3.0pt;\n\tmargin-left:.5in;\n\tline-height:120%;\n\tfont-size:10.5pt;\n\tfont-family:"Calibri",sans-serif;\n\tcolor:#595959;}\np.p1, li.p1, div.p1\n\t{mso-style-name:p1;\n\tmargin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:6.0pt;\n\tmargin-left:0in;\n\tline-height:120%;\n\tfont-size:28.0pt;\n\tfont-family:Helvetica;\n\tcolor:#232323;}\nspan.s1\n\t{mso-style-name:s1;}\nspan.Heading1Char\n\t{mso-style-name:"Heading 1 Char";\n\tmso-style-link:"Heading 1";\n\tfont-family:"Times New Roman",serif;\n\tcolor:#5B9BD5;\n\tfont-weight:bold;}\nspan.TitleChar\n\t{mso-style-name:"Title Char";\n\tmso-style-link:Title;\n\tfont-family:"Calibri Light",sans-serif;\n\tletter-spacing:-.5pt;}\nspan.Heading2Char\n\t{mso-style-name:"Heading 2 Char";\n\tmso-style-link:"Heading 2";\n\tfont-family:"Roboto Light";\n\tcolor:#595959;\n\ttext-decoration:underline;}\n.MsoChpDefault\n\t{font-size:12.0pt;\n\tfont-family:"Calibri",sans-serif;}\n@page WordSection1\n\t{size:8.5in 11.0in;\n\tmargin:1.0in 1.0in 1.0in 1.0in;}\ndiv.WordSection1\n\t{page:WordSection1;}\n /* List Definitions */\n ol\n\t{margin-bottom:0in;}\nul\n\t{margin-bottom:0in;}\n-->\n',
          }}
        />
        <div className="WordSection1">
          <p className="p1">
            <span className="s1">
              <span style={{ fontFamily: '"Calibri",sans-serif' }}>&nbsp;</span>
            </span>
          </p>
          <p className="MsoTitle">
            <span style={{ fontFamily: '"Calibri",sans-serif' }}>
              Privacy Policy
            </span>
          </p>

          <p className="MsoNormal">&nbsp;</p>
          <p className="MsoNormal">
            ClassGenius, Inc. ("<b>ClassGenius</b>") designs products and tools
            that elevate teacher productivity and strengthen student learning.
          </p>
          <p className="MsoNormal">
            This Privacy Policy describes our practices regarding the Personal
            Data (as defined below) we collect from users of our ClassGenius web
            applications ("<b>Apps</b>"), the services available through the use
            of our Apps (the "<b>Services</b>"), our website,
            www.classgenius.ai, and all related websites that post this Privacy
            Policy ("<b>Sites</b>").
          </p>
          <p className="MsoNormal">
            <span style={{ fontSize: "12.0pt", lineHeight: "120%" }}>
              PLEASE READ THIS POLICY CAREFULLY TO UNDERSTAND OUR POLICIES AND
              PRACTICES REGARDING YOUR INFORMATION AND HOW WE WILL TREAT IT. IF
              YOU DO NOT AGREE WITH OUR POLICIES AND PRACTICES, PLEASE DO NOT
              USE OUR APPS OR SERVICES. BY ACCESSING OR USING THE APPS OR
              SERVICES, YOU AGREE TO THIS PRIVACY POLICY.
            </span>
          </p>
          <p className="MsoNormal">
            And remember, we’re here to help.&nbsp; If something in this policy
            does not make sense or if you have any questions, please contact us
            at help@classgenius.ai.
          </p>
          <h1>
            <span style={{ lineHeight: "120%" }}>
              1.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            Kinds of Data We Collect from You
          </h1>
          <p className="MsoNormal">
            <b>"</b>
            <b>Personal Data</b>
            <b>" </b>means data that allows someone to identify or contact you,
            including, for example, your name, address, telephone number, e-mail
            address, credit-card or other payment information (if applicable),
            certain health information, as well as any other non-public
            information about you that is associated with or linked to any of
            the foregoing data, or any other information or data that you
            provide when using our Apps or Services.{" "}
          </p>
          <p className="MsoNormal">
            <b>"</b>
            <b>Anonymous Data</b>
            <b>" </b>means data that is not associated with or linked to your
            Personal Data; Anonymous Data does not, by itself, permit the
            identification of individual persons. Anonymous Data is information
            we obtain automatically from your connection, interaction with the
            Apps and the use of Cookies and other technologies.{" "}
          </p>
          <p className="MsoNormal">
            We collect Personal Data and Anonymous Data from users who register
            an account ("<b>User</b>").&nbsp; We collect Personal Data and
            Anonymous Data that you provide to us directly, through your use of
            the Apps, Sites and/or ClassGenius Services as a User. We may also
            collect Personal Data or Anonymous Data automatically, through
            technologies used on the Sites, Apps and in the Services, as
            described below.
          </p>
          <p className="MsoNormal">
            We collect Personal Data and Anonymous Data, as described below.
          </p>
          <h1>
            <span style={{ lineHeight: "120%" }}>
              2.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            What Data Does ClassGenius Collect?
          </h1>
          <p className="MsoNormal">
            ClassGenius uses your data to improve the ClassGenius Apps and
            Services.{" "}
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              2.1.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            We collect the following information directly through our Apps and
            Services:
          </h2>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (a)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            To make use of the ClassGenius Apps and Services, you must register
            for an account.&nbsp; We collect Personal Data from you when you
            register for an account to use the ClassGenius Apps and/or Services
            ("<b>Account</b>"). To establish your Account, we collect your first
            name, last name, school affiliation, grades and subjects taught
            through the Sites. We use Google Sign for authentication and collect
            your email address via Google Sign in.
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (b)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
            We collect additional Personal Data when you create a ClassGenius
            Account profile (<b>"Profile"</b>). To establish your Profile, we
            may collect your ZIP Code, address, phone number(s), handedness,
            date of birth. We may also collect information about the curricula
            you follow, your teaching preferences, methods, and styles. We do
            not collect Profile information that would identify you unless you
            choose to provide it to us. You can choose not to provide us with
            certain Profile information, but please be aware that may restrict
            your access to certain Services and/or impact the Services provided
            to you.
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (c)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            We collect information about your interactions with the Apps and
            Services.
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (d)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
            Our Services may ask you for inputs or information via notifications
            or SMS messages on your mobile phone, via surveys built into our
            Apps, via surveys built using a third party platform, via email, and
            via phone, video, or in-person interviews and conversations. We
            collect the information you provide in response to those requests
            for information.
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (e)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
            Our Apps and Services may allow you to add certain types of
            information to your account, such as for example personalized
            rubrics, personalized grading criteria, information related to the
            generation of reading comprehension passages and assessments.
            Whenever you provide this kind of data, we collect it and add it to
            your ClassGenius account.
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (f)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            We may collect information about your device environment, such as
            device manufacturer, operating system, and browser information.
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (g)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            As a user of Apps and Services that are still under development, we
            may collect Personal Data from you outside of our Sites, Apps and
            Services. We may collect information, data and logs from you that
            may include Personal Data by oral, written or electronic
            communication with you. We may collect information data and logs
            that may include Personal Data in paper format or in other
            electronic formats including but not limited to spreadsheets.&nbsp;
            You can choose not to provide us with certain Personal information
            that is collected in this way, but please be aware that may restrict
            you access to certain Services and/or may impact the Services
            provided to you.
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              2.2.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            We collect the following information from all users of the Sites:
          </h2>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (a)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            When you sign up for our mailing list, we collect your e-mail
            address.
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (b)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
            When you contact us through our Sites, we collect your First Name,
            Last Name, Company Name or School Affilitaion (if applicable),
            e-mail address and the content of your message to us.
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              2.3.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            We collect the following information from all users through the
            Sites or the Apps or Services:
          </h2>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            <span style={{ fontFamily: "Roboto" }}>
              (a)
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;
              </span>
            </span>
            <b>Personal Data. &nbsp;</b>When you participate in one of our
            surveys, we may collect additional Personal Data to complete the
            survey. If you contact us for support regarding the ClassGenius Apps
            or Services, we may collect your name, e-mail address, phone number,
            as well as certain device information such as model, make, operating
            system, browser, and version, and any communications or
            correspondence that you send us.
          </p>
          <p className="MsoListParagraph" style={{ marginLeft: ".25in" }}>
            Please note that at all times you are responsible for updating your
            Personal Data to provide us with your most current contact
            information, including e-mail address.
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            <span style={{ fontFamily: "Roboto" }}>
              (b)
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;
              </span>
            </span>
            <b>Location Information.&nbsp;</b>If you have enabled location
            services on your device, we may collect geolocation information to
            improve or customize our Apps and Services.&nbsp; We may share your
            geo-location data with third parties for the purpose of them serving
            you ads. If you do not wish to allow us to share your information in
            this manner please opt-out by contacting us at{" "}
            <a href="../28ce214d-6f81-4ca7-95fc-5ffb47bf445c-39bcaa56-757f-489f-a97e-b700038bfa9d/help@classgenius.ai">
              help@classgenius.ai
            </a>
            .
          </p>
          <p className="MsoListParagraph" style={{ marginLeft: ".25in" }}>
            If you do not want to provide us with your location information, you
            can deactivate geolocation services on your device.
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            <span style={{ fontFamily: "Roboto" }}>
              (c)
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;
              </span>
            </span>
            <b>Information We Receive from Third Parties.&nbsp;</b>We may
            receive Personal Data from third party sources. We may add this
            information to the information we have already collected from you
            directly via the ClassGenius Services.
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            <span style={{ fontFamily: "Roboto" }}>
              (d)
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;
              </span>
            </span>
            <b>Information Collected Automatically via Technology.</b>
            Technologies such as Cookies may be used by ClassGenius and our
            partners, affiliates or analytics or service providers. These
            technologies are used in analyzing trends, administering the
            website, tracking users' movements around the site, and gathering
            demographic information about our user base as a whole. We may
            receive reports based on the use of these technologies by these
            companies on an individual and aggregated basis.
          </p>
          <p className="MsoListParagraph" style={{ marginLeft: ".25in" }}>
            Users can control the use of cookies at the individual browser
            level. If you reject cookies, you may still use our website, but
            your ability to use some features or areas of our website may be
            limited.&nbsp;
          </p>
          <p className="MsoListParagraph" style={{ marginLeft: ".25in" }}>
            <i>Information Collected by Our Servers.</i> To make our Sites and
            ClassGenius Services more useful to you, our servers (which may be
            hosted by a third party service provider) collect information from
            you, including your browser type, operating system, Internet
            Protocol (<b>"IP"</b>) address (a number that is automatically
            assigned to your computer when you use the Internet, which may vary
            from session to session), domain name, and/or a date/time stamp for
            your visit.
          </p>
          <p className="MsoListParagraph" style={{ marginLeft: ".25in" }}>
            <i>Log Files.&nbsp;</i>As is true of most websites, we gather
            certain information automatically and store it in log files. This
            information includes IP addresses, browser type, Internet service
            provider (<b>"ISP"</b>), referring/exit pages, operating system,
            date/time stamp, and clickstream data. We may combine this
            automatically collected log information with other information we
            collect about you. We do this to improve the Services we offer to
            you, improve marketing and site functionality.
          </p>
          <p className="MsoListParagraph" style={{ marginLeft: ".25in" }}>
            We use this information to analyze trends, administer the Sites,
            track users' movements around the Sites, gather demographic
            information about our user base as a whole, and better tailor our
            ClassGenius Services to our users' needs. For example, some of the
            information may be collected so that when you visit the Sites or the
            ClassGenius Services again, it will recognize you and the
            information could then be used to serve advertisements and other
            information appropriate to your interests.&nbsp;
          </p>
          <p className="MsoListParagraph" style={{ marginLeft: ".25in" }}>
            <i>Mobile Services.</i> We may also collect non-personal information
            from your device. This information is generally used to help us
            deliver the most relevant information to you. Examples of
            information that may be collected and used include your geographic
            location, how you use the Apps, and information about the type of
            device you use. In addition, in the event our Apps crash on your
            device, we will receive information about your device model software
            version, which allows us to identify and fix bugs and otherwise
            improve the performance of our Apps. This information is sent to us
            as aggregated information and is not traceable to any individual and
            cannot be used to identify an individual.
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            <b>
              <span style={{ fontFamily: "Roboto" }}>
                (e)
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;
                </span>
              </span>
            </b>
            <b>Third Party Analytics and Tracking. </b>
          </p>
          <p className="MsoListParagraph" style={{ marginLeft: ".25in" }}>
            <i>How We Respond to Do Not Track Signals.</i> We do not currently
            respond to "do not track" signals or other mechanisms that might
            enable consumers to opt out of tracking on our Website.&nbsp;
          </p>
          <p className="MsoListParagraph" style={{ marginLeft: ".25in" }}>
            <i>Collection of Data by Advertisers&nbsp;.</i> We may also use
            third parties to serve ads on the Sites or Apps. Regardless of
            whether they serve ads on our Sites or Apps, certain third parties
            may automatically collect information about your visits to our Sites
            or Apps and other websites, your IP address, your ISP, and the
            browser you use to visit our Sites (but not your name, address,
            e-mail address or telephone number). They do this by using Cookies,
            Pixel Tags, or other technologies. Information collected may be
            used, among other things, to deliver advertising targeted to your
            interests and to better understand the usage and visitation of our
            Sites and the other sites tracked by these third parties. This
            Privacy Policy does not apply to, and we are not responsible for,
            Cookies or Pixel Tags in third party ads, and we encourage you to
            check the privacy policies of advertisers and/or ad services to
            learn about their use of Cookies and other technologies. If you
            would like more information about this practice or if you choose to
            opt out of tracking conducted by certain third party companies that
            honor such opt-outs, click here:{" "}
            <a href="http://www.aboutads.info/choices">
              <span style={{ color: "#0032A0" }}>
                http://www.aboutads.info/choices
              </span>
            </a>
            &nbsp;or
            <a href="http://www.networkadvertising.org/">
              <span style={{ color: "#0032A0" }}>
                http://www.networkadvertising.org
              </span>
            </a>
            .
          </p>
          <p className="MsoListParagraph" style={{ marginLeft: ".25in" }}>
            <i>Analytics Tools.</i> We use analytics tools, such as Google
            Analytics, (<b>"Analytics Tools"</b>) to help analyze how users use
            the Sites and Apps. For example, Google Analytics uses Cookies to
            collect information such as how often users visit the Sites, what
            pages they visit, and what other sites they used prior to coming to
            the Sites. We use the information we get from Analytics Tools only
            to improve the ClassGenius Services. Google Analytics collects only
            the IP address assigned to you on the date you visit the Website,
            rather than your name or other personally identifying information.
            Although Google Analytics plants a persistent Cookie on your web
            browser to identify you as a unique user the next time you visit the
            Website, the Cookie cannot be used by anyone but Google. Google's
            ability to use and share information collected by Google Analytics
            about your visits to the Website is governed by the Google Analytics
            Terms of Use and the Google Privacy Policy.
          </p>
          <p className="MsoListParagraph" style={{ marginLeft: ".25in" }}>
            For<b>&nbsp;</b>more information on Google's privacy practices,
            please click here:{" "}
            <a href="https://www.google.com/intl/en/analytics/learn/privacy.html">
              <span style={{ color: "#0032A0" }}>
                https://www.google.com/intl/en/analytics/learn/privacy.html
              </span>
            </a>
            .
          </p>
          <p className="MsoListParagraph" style={{ marginLeft: ".25in" }}>
            For information about how to opt out of Google Analytics, please
            click here:{" "}
            <a href="https://tools.google.com/dlpage/gaoptout">
              <span style={{ color: "#0032A0" }}>
                https://tools.google.com/dlpage/gaoptout
              </span>
            </a>
            <b>.</b>
          </p>
          <h1>
            <span style={{ lineHeight: "120%" }}>
              3.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            How We Use Your Personal Data
          </h1>
          <h2>
            <span style={{ textDecoration: "none" }}>
              3.1.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            <b>General Use.&nbsp;</b>We use your Personal Data in the following
            ways:
          </h2>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (a)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            To facilitate the creation and administration of your Account and
            Profile;
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (b)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
            To send you e-mails;
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (c)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            To identify you as a user in our system;
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (d)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
            To respond to your inquiries or customer service requests;
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (e)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
            To provide you with the ClassGenius Services;
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (f)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            To improve, troubleshoot and protect our Apps and Services.&nbsp;
            For example, data and logs are used in research to understand,
            troubleshoot and improve the ClassGenius Apps and Services, to
            detect and protect against error, fraud or other criminal activity;
            and to enforce the ClassGenius Terms &amp; Conditions;{" "}
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (g)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            To display the history of parameters related to your use of the Apps
            and Services.
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (h)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;{" "}
            </span>
            To provide improved administration of our Sites, Apps, and Services;
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (i)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            To improve the quality of your experience when you interact with our
            Sites, Apps, and Services;
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (j)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            To send you administrative e-mail notifications, such as security or
            support and maintenance advisories;
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (k)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            To send you reminders and notifications related to our Services; and
          </p>
          <p
            className="MsoListParagraph"
            style={{ marginLeft: ".25in", textIndent: "-.25in" }}
          >
            (l)
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
            </span>
            To send you newsletters, surveys, offers, and other promotional
            materials related to the Services and for other marketing purposes
            of ClassGenius.
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              3.2.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            User Testimonials and Feedback About Your Use of the ClassGenius
            Services.&nbsp;
          </h2>
          <p className="MsoNormal">
            We often receive testimonials and comments from users who have had
            positive experiences with our ClassGenius Services. We may post user
            feedback on the Sites or in the Apps from time to time. We will
            share your feedback with your first name and last initial only. If
            we choose to post your first and last name along with your feedback,
            we will obtain your consent prior to posting you name with your
            feedback. If you wish to update or delete your testimonial, you can
            contact us at{" "}
            <a href="../28ce214d-6f81-4ca7-95fc-5ffb47bf445c-39bcaa56-757f-489f-a97e-b700038bfa9d/help@classgenius.ai">
              help@classgenius.ai
            </a>
            .
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              3.3.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            Creation of Anonymous Data.&nbsp;
          </h2>
          <p className="MsoNormal">
            We may create Anonymous Data records from Personal Data by excluding
            information (such as your name) that makes the data personally
            identifiable to you. We use this Anonymous Data for example to
            expand our library of content, and to analyze request and usage
            patterns so that we may enhance the content of our Services and
            improve Site navigation.{" "}
          </p>
          <p className="MsoNormal">
            We reserve the right to use Anonymous Data for any purpose and
            disclose Anonymous Data to third parties in our sole discretion.
          </p>
          <h1>
            <span style={{ lineHeight: "120%" }}>
              4.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            What Kinds of Data We Share
          </h1>
          <p className="MsoNormal">
            We will share/disclose your Personal Data with third party as
            described below and as described elsewhere in this Privacy Policy.
            If we plan to use or disclose Personal Data for any purposes or to
            any recipient other than those described in this Privacy Policy, we
            will notify you prior to such use or disclosure and obtain your
            consent prior to disclosure.
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              4.1.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            Third Party Service Providers
          </h2>
          <p className="MsoNormal">
            We may share your Personal Data with third party service providers
            to: provide you with the ClassGenius Services; facilitate online
            shopping and process payments for Products; conduct quality
            assurance testing; facilitate creation of Accounts; provide
            technical support; and/or provide other services to ClassGenius.
            These third party service providers are required not to use your
            Personal Data other than to provide the services requested by
            ClassGenius.
          </p>
          <p className="MsoNormal">
            If you do not want us to share your personal information with these
            companies, you may contact us at:{" "}
            <a href="../28ce214d-6f81-4ca7-95fc-5ffb47bf445c-39bcaa56-757f-489f-a97e-b700038bfa9d/help@classgenius.ai">
              help@classgenius.ai
            </a>
            .
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              4.2.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            Affiliates
          </h2>
          <p className="MsoNormal">
            We may share some or all of your Personal Data with our parent
            company, subsidiaries, joint ventures, or other companies under a
            common control ("
            <b>Affiliates</b>"), in which case we will require our Affiliates to
            honor this Privacy Policy.
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              4.3.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            Corporate Restructuring
          </h2>
          <p className="MsoNormal">
            We may share some or all of your Personal Data in connection with or
            during negotiation of any merger, financing, acquisition or
            dissolution transaction or proceeding involving sale, transfer,
            divestiture, or disclosure of all or a portion of our business or
            assets. In the event of an insolvency, bankruptcy, or receivership,
            Personal Data may also be transferred as a business asset. If
            another company acquires the ClassGenius business or assets, that
            company will possess the Personal Data collected by us and will
            assume the rights and obligations regarding your Personal Data as
            described in this Privacy Policy.
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              4.4.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            Other Disclosures
          </h2>
          <p className="MsoNormal">
            Regardless of any choices you make regarding your Personal Data (as
            described below), In certain situations, ClassGenius may be required
            to&nbsp;disclose&nbsp;Personal Data in response to lawful requests
            by public authorities, including to meet national security or law
            enforcement requirements. &nbsp;ClassGenius may disclose Personal
            Data if it believes in good faith that such disclosure is necessary
            (a) in connection with any legal investigation; (b) to comply with
            relevant laws or to respond to subpoenas or warrants served on
            ClassGenius; (c) to protect or defend the rights or property of
            ClassGenius or users of the Sites, Apps or ClassGenius Services;
            and/or (d) to investigate or assist in preventing any violation or
            potential violation of the law, this Privacy Policy, or our Terms
            &amp; Conditions.
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              4.5.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            Sensitive Personal Information
          </h2>
          <p className="MsoNormal">
            You understand and agree that, in the event you provide ClassGenius
            with Sensitive Personal Information, such Sensitive Personal
            Information may be processed and transferred in accordance with the
            terms of this Privacy Policy, and you hereby consent to such
            processing and transfer of your Sensitive Personal Information. "
            <b>Sensitive Personal Information</b>" includes information
            regarding racial or ethnic origin, political opinions, religious or
            philosophical beliefs, trade union membership and health or sex
            life.
          </p>
          <h1>
            <span style={{ lineHeight: "120%" }}>
              5.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            How does ClassGenius Keep my Data Safe?
          </h1>
          <p className="MsoNormal">
            If you have any questions about the security of your personal
            information, you can contact us at{" "}
            <a href="../28ce214d-6f81-4ca7-95fc-5ffb47bf445c-39bcaa56-757f-489f-a97e-b700038bfa9d/help@classgenius.ai">
              help@classgenius.ai
            </a>
            .&nbsp;
          </p>
          <p className="MsoNormal">
            Please do not disclose your Account password to unauthorized people.
            If you discover or suspect that your password has been disclosed or
            accessed by an unauthorized person, please contact us using the
            contact information provided above.
          </p>
          <h1>
            <span style={{ lineHeight: "120%" }}>
              6.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            Your Choices Regarding Information
          </h1>
          <p className="MsoNormal">
            You have several choices regarding the use of information on our
            Services:
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              6.1.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            Email Communications
          </h2>
          <p className="MsoNormal">
            We will periodically send you newsletters and e-mails that directly
            promote the use of our Product, Apps, or Services. When you receive
            newsletters or promotional communications from us, you may indicate
            a preference to stop receiving further communications from us and
            you will have the opportunity to "opt-out" by contacting us directly
            using the contact information provided above. Despite your indicated
            e-mail preferences, we may send you service related communications,
            including notices of any updates to our Terms and Conditions or
            Privacy Policy.
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              6.2.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            Cookies
          </h2>
          <p className="MsoNormal">
            If you decide that you no longer wish to accept Cookies from the
            Services for any of the purposes described above, you can change
            your browser's settings, if your browser permits, to stop accepting
            Cookies or to prompt you before accepting a Cookie from the websites
            you visit. Consult your browser's technical information. If you do
            not accept Cookies, however, you may not be able to use all portions
            of the Services or all functionality of the Services. If you have
            any questions about how to disable or modify Cookies, please let us
            know at the contact information provided above.
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              6.3.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            Accessing, Changing or Deleting Your Personal Data.&nbsp;
          </h2>
          <p className="MsoNormal">
            Upon request ClassGenius will provide you with information about
            whether we hold, or process on behalf of a third party, any of your
            personal information. <b>You may change, correct</b>, update any of
            your Personal Data in your Account by editing your profile within
            your Account (if this feature is available to you) or by contacting
            us directly using the contact information above.{" "}
          </p>
          <p className="MsoNormal">
            You may request deletion of your Personal Data by contacting us
            directly using the contact information above, and we will use
            commercially reasonable efforts to honor your request. We will
            respond to your request within a reasonable timeframe. Please note
            that we may be required to keep such information and not delete it
            (or to keep this information for a certain time, in which case we
            will comply with your deletion request only after we have fulfilled
            such requirements). When we delete any information, it will be
            deleted from the active database, but may remain in our archives. We
            may also retain your information for fraud or similar purposes.
          </p>
          <p className="MsoNormal">
            Will retain your information for as long as your account is active
            or as needed to provide you services. We will retain and use your
            information as necessary to comply with our legal obligations,
            resolve disputes, and enforce our agreements.
          </p>
          <h2>
            <span style={{ textDecoration: "none" }}>
              6.4.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;</span>
            </span>
            Applications
          </h2>
          <p className="MsoNormal">
            You can stop all collection of information by the Apps by logging
            out of the Apps. To serve ads in our Apps where Cookie technology is
            not available, ClassGenius hashes users' device IDs. Users may
            choose to reset or opt out of anonymous IDs at any time. If users
            choose to opt out, ads delivered to the Apps by ad serving
            technology will not be served on an anonymous ID. You may at any
            time opt-out from further allowing us to have access to your
            location data by disabling location services in your smartphone
            settings.
          </p>
          <h1>
            <span style={{ lineHeight: "120%" }}>
              7.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            Third Party Websites
          </h1>
          <p className="MsoNormal">
            Our Sites or Apps may contain links to third party websites. When
            you click on a link to any other website or location, you will leave
            our Sites or Apps and go to another site, and another entity may
            collect Personal Data or Anonymous Data from you. We have no control
            over, do not review, and cannot be responsible for, these outside
            websites or their content. Please be aware that the terms of this
            Privacy Policy do not apply to these outside websites or content, or
            to any collection of your Personal Data after you click on links to
            such outside websites. We encourage you to read the privacy policies
            of every website you visit. The links to third party websites or
            locations are for your convenience and do not signify our
            endorsement of such third parties or their products, content or
            websites.
          </p>
          <h1>
            <span style={{ lineHeight: "120%" }}>
              8.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            Changes to this Privacy Policy
          </h1>
          <p className="MsoNormal">
            This Privacy Policy is subject to occasional revision. If we change
            it, we will post the then-current Privacy Policy on this page and
            update the "Last Updated" date above. Any non-material changes to
            this Privacy Policy will be effective as of the day they are posted.
            If we make any material changes in the way we use your Personal
            Data, we will notify you by sending you an e-mail to the last e-mail
            address you provided to us and/or by prominently posting notice of
            the changes on our Sites.{" "}
          </p>
          <p className="MsoNormal">
            Any changes to this Privacy Policy will be effective upon the
            earlier of thirty (30) calendar days following our dispatch of an
            e-mail notice to you or thirty (30) calendar days following our
            posting of notice of the changes on our Sites. These changes will be
            effective immediately for new users of our ClassGenius Services.{" "}
          </p>
          <p className="MsoNormal">
            Please note that at all times you are responsible for updating your
            Personal Data to provide us with your most current e-mail address.
            In the event that the last e-mail address that you have provided us
            is not valid, or for any reason is not capable of delivering to you
            the notice described above, our dispatch of the e-mail containing
            such notice will nonetheless constitute effective notice of the
            changes described in the notice.
          </p>
          <p className="MsoNormal">
            If you do not wish to permit changes in our use of your Personal
            Data, you must notify us prior to the effective date of the changes
            that you wish to deactivate your Account with us. Continued use of
            our Sites, Apps, or Services, following notice of such changes shall
            indicate your acknowledgement of such changes and agreement to be
            bound by the terms and conditions of such changes.
          </p>
          <p className="MsoNormal">&nbsp;</p>
        </div>
      </>
    </div>
  );
}

export default Privacy;
